import React, { useContext, useState, useEffect, useMemo } from 'react';
import Appointments from './Appointments';
import { DashboardContext } from 'context/DashboardContext';
import { ModalContext } from 'context/ModalContext';
import { close_appointment, getAppointmentCreatedForIntermediary, listAppointments } from 'services/appointmentSrv';
import Loader from 'components/widgets/loader';
import { message } from 'antd';
import { useQuery } from 'react-query';

const AppointmentContainer = () => {
  const {
    currentEvents,
    setCurrentEvents,
    selectedObject,
    appointment,
    setAppointment,
    setSelectedObject,
    refreshAppointments,
    setRefreshAppointments,
  } = useContext(DashboardContext);
  const { setModalShow } = useContext(ModalContext);

  const [weekendsVisible, setWeekendsVisible] = useState(true);
  const [appointmentId, setAppointmentId] = useState('');
  const [clicked, setClicked] = useState(false);
  const [appointmentShow, setAppointmentShow] = useState(false);

  // Handlers
  const hide = () => setClicked(false);

  const modalAppointmentsClose = () => {
    setAppointmentShow(false);
    setRefreshAppointments(true); // Trigger refresh after modal close
  };

  const handleClickChange = () => setAppointmentShow(true);

  const handleWeekendsToggle = () => setWeekendsVisible(prev => !prev);

  // Fetch appointments list
  const fetchAppointments = async () => {
    const resp = await listAppointments({ page: 1 });
    return resp?.data[0]?.items || [];
  };

  const {
    isLoading: appointmentsLoading,
    data: appointmentsData,
    refetch: refetchAppointments,
  } = useQuery('appointments', fetchAppointments, {
    onSuccess: (data) => {
      setCurrentEvents(data);
      setRefreshAppointments(false); // Reset flag
    },
    staleTime: 5 * 60 * 1000, // 5 minutes
  });

  console.log("appointments", appointmentsData)
  // Trigger refetch when refreshAppointments is true
  useEffect(() => {
    if (refreshAppointments) {
      refetchAppointments();
    }
  }, [refreshAppointments, refetchAppointments]);

  // Transform appointments into FullCalendar format
  const events = useMemo(() => {
    if (!appointmentsData) return [];

    return appointmentsData.map(item => ({
      id: item.appointmentSystemRef,
      title: item.message,
      start: item.appointmentDate,
      status: item.status,
      createdBy: item.createdBy
      
    }));
  }, [appointmentsData]);

  // Handle date selection (for creating new event)
  const handleDateSelect = (selectInfo) => {
    const selectedDate = selectInfo.start;
    const today = new Date();
    const selectDay = new Date(selectedDate).getDate();
    const currentDay = today.getDate();

    if (selectDay >= currentDay || selectedDate >= today.setHours(0, 0, 0, 0)) {
      setAppointment({ ...appointment, date: selectedDate });
      setSelectedObject(selectInfo);
      setModalShow(true);
    } else {
      message.error('Cannot schedule appointments in the past');
    }
  };

  // Handle event click
  const handleEventClick = (clickInfo) => {
    const id = clickInfo.event._def.publicId;
    
    console.log("id for app", clickInfo)
    setAppointmentId(id);
    setAppointmentShow(true);
    setClicked(true);
  };

  // Handle appointment close
  const handleRemove = async (id) => {
    // try {
    //   await close_appointment(id);
    //   message.success('Appointment closed successfully');
    //   setRefreshAppointments(true); // Refresh list
    // } catch (err) {
    //   console.error('Error closing appointment:', err);
    //   message.error('Failed to close appointment');
    // }
  };
  

  async function getAppointment(ref) {
    const refLength = Array.isArray(ref) ? ref.length : String(ref).length;

    if (refLength === 1) {
        const sortedAppointments = [...appointmentsData].sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        return sortedAppointments[0]; 
    }

    const res = await getAppointmentCreatedForIntermediary(ref);
    return res.data;
}


  // Fetch single appointment details
  const {
    data: details,
    isLoading: detailsLoading,
    isSuccess: successDetails,
    isError: errorDetails,
    refetch: refetchAppointment
  } = useQuery(
    ['appointment-details', appointmentId],
    () => getAppointment(appointmentId),
    {
      enabled: !!appointmentId,
      refetchOnWindowFocus: false,
      staleTime: 2 * 60 * 1000,
    }
  );
  

  // Optional: Refetch appointments list when appointmentId changes (if needed)
  // Remove if not necessary
  useEffect(() => {
    if (appointmentId) refetchAppointment(appointmentId);
  }, [appointmentId, refetchAppointment]);

  return (
    <>
      {appointmentsLoading && <Loader />}

      {appointmentsData && (
        <Appointments
          appointmentId={appointmentId}
          refetchAppointment
          state={events}
          hide={hide}
          handleWeekendsToggle={handleWeekendsToggle}
          handleDateSelect={handleDateSelect}
          handleEventClick={handleEventClick}
          weekendsVisible={weekendsVisible}
          handleRemove={handleRemove}
          handleClickChange={handleClickChange}
          clicked={clicked}
          modalAppointmentsClose={modalAppointmentsClose}
          appointmentShow={appointmentShow}
          details={details}
          detailsLoading={detailsLoading}
          successDetails={successDetails}
          errorDetails={errorDetails}
        />
      )}
    </>
  );
};

export default AppointmentContainer;